(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-cart-upsell')) {
    customElements.define(
      'bundle-cart-upsell',
      class BundleCartUpsell extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-addon-button]').forEach((button) => {
            button.addEventListener('click', () => this.addItem(button));
          });
        }

        addItem(button) {
          const kind = button.dataset.addonButton;
          const context = button.dataset.addonContext;
          const select = this.querySelector('[data-addon-select="' + kind + '"]');
          const error = this.querySelector('.dtcc-cart-upsell__error');
          const drawer = document.querySelector('cart-drawer');

          if (!select || !select.value || !drawer) return;

          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          error.hidden = true;

          const sections = drawer.getSectionsToRender().map((section) => section.id);
          const propertyPrefix = context === 'bundle' ? '_dtcc_bundle_' : '_dtcc_standalone_';
          const selectedOption = select.options[select.selectedIndex];
          const discountCode = button.dataset.discountCode || selectedOption.dataset.discountCode || '';
          let offer;

          if (context === 'bundle') {
            offer = kind === 'bag' ? '12 oz bag for $17' : '2 oz sample for $6';
          } else if (kind === 'bag' || kind === 'sample') {
            offer = button.dataset.offerLabel;
          } else {
            offer = 'Mug for ' + (selectedOption.dataset.offerPrice || '$15');
          }

          const properties = {};
          properties[propertyPrefix + 'add_on'] = kind;
          properties[propertyPrefix + 'offer'] = offer;

          const body = {
            items: [
              {
                id: Number(select.value),
                quantity: 1,
                properties: properties
              }
            ],
            sections: sections,
            sections_url: window.location.pathname
          };

          fetch(routes.cart_add_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(body)
          })
            .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
            .then(({ ok, data }) => {
              if (!ok || data.status) throw new Error(data.description || data.message || 'Unable to add this item.');

              if (!discountCode) return data;

              return fetch(routes.cart_url + '.js', {
                headers: { Accept: 'application/json' }
              })
                .then((response) => response.json())
                .then((cartData) => {
                  const attributeName = '_dtcc_addon_discount_codes__';
                  const savedCodes = (cartData.attributes && cartData.attributes[attributeName]
                    ? cartData.attributes[attributeName].split(',')
                    : []
                  ).filter(Boolean);

                  if (!savedCodes.includes(discountCode)) savedCodes.push(discountCode);

                  return fetch(routes.cart_update_url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      Accept: 'application/json'
                    },
                    body: JSON.stringify({
                      discount: savedCodes.join(','),
                      attributes: { [attributeName]: savedCodes.join(',') },
                      sections: sections,
                      sections_url: window.location.pathname
                    })
                  }).then((response) => response.json().then((updatedData) => ({ ok: response.ok, data: updatedData })));
                })
                .then(({ ok, data: updatedData }) => {
                  if (!ok || updatedData.status) {
                    throw new Error(updatedData.description || updatedData.message || 'The item was added, but its add-on price could not be applied.');
                  }
                  return updatedData;
                });
            })
            .then((data) => {
              drawer.renderContents(data);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-cart-upsell', cartData: data });
              }
            })
            .catch((exception) => {
              error.textContent = exception.message || 'Unable to add this item. Please try again.';
              error.hidden = false;
              button.disabled = false;
              button.removeAttribute('aria-busy');
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
